import { Merch, decorationSchema, hasDecorations, merchSchema } from '@theprintbar/shared';
import { openDB } from 'idb';
import { z } from 'zod';

const merchStorageKey = 'TPBMerchSession';

async function getDB() {
	try {
		return openDB(merchStorageKey, 1, {
			upgrade(db) {
				if (!db.objectStoreNames.contains(merchStorageKey)) {
					db.createObjectStore(merchStorageKey);
				}
			},
		});
	} catch (e) {
		console.error('Failed to open IndexedDB', e);
		return null;
	}
}

const merchSessionSchema = merchSchema.extend({
	decorations: z.array(decorationSchema.extend({ artwork: z.any().optional() })),
});

export type MerchSession = z.infer<typeof merchSessionSchema>;

export async function getMerchSession() {
	if (typeof window === 'undefined') return null;
	const db = await getDB();
	try {
		const merch = (await db?.get(merchStorageKey, window.location.href)) as MerchSession;
		if (!merch) return null;
		if (!merch.decorations.find(decoration => !!decoration.artwork)) {
			clearMerchSession();
			return null;
		}
		return merch;
	} catch (e) {
		await db?.delete(merchStorageKey, window.location.href);
	}
}

export async function saveMerchSession(merch: Merch) {
	if (typeof window === 'undefined') return null;
	const db = await getDB();

	try {
		if (hasDecorations(merch)) {
			await db?.put(merchStorageKey, merch, window.location.href);
		} else {
			await db?.delete(merchStorageKey, window.location.href);
		}
	} catch (e) {
		console.log(e);
		sessionStorage.removeItem(merchStorageKey);
	}
}

export async function clearMerchSession() {
	if (typeof window === 'undefined') return null;
	const db = await getDB();

	try {
		await db?.delete(merchStorageKey, window.location.href);
	} catch (e) {
		console.log(e);
	}
	return null;
}
